module.exports = __webpack_public_path__ + "static/Selma_Online_Teaching_Guide-44b615b579370a298f0f1fac47032ab2.pdf";